import { ColorProps } from '@chakra-ui/react'

import { OfferStatusEnum } from '@wwt/entities/api/search-response'

export const statusColors: Record<OfferStatusEnum, ColorProps['color']> = {
	AVAILABLE: 'gray.100',
	EXPIRED_DATES: 'red.100',
	NOT_AVAILABLE: 'red.100',
	RESERVATION_PENDING: 'yellow.100',
	RESERVATION_FAILED: 'red.100',
	RESERVED: 'green.100',
	RESERVATION_CANCELLED: 'gray.100',
	RESERVATION_CANCEL_PENDING: 'yellow.100',
	RESERVATION_CANCEL_FAILED: 'red.100',
	PAYMENT_PENDING: 'yellow.100',
	PAYMENT_FAILED: 'red.100',
	TRIP_COMPLETED: 'green.100'
}

export const statusColorsAsCSSVariables: Record<
	OfferStatusEnum,
	ColorProps['color']
> = {
	AVAILABLE: '--color-gray-100',
	EXPIRED_DATES: '--color-red-100',
	NOT_AVAILABLE: '--color-red-100',
	RESERVATION_PENDING: '--color-yellow-100',
	RESERVATION_FAILED: '--color-red-100',
	RESERVED: '--color-green-100',
	RESERVATION_CANCELLED: '--color-gray-100',
	RESERVATION_CANCEL_PENDING: '--color-yellow-100',
	RESERVATION_CANCEL_FAILED: '--color-red-100',
	PAYMENT_PENDING: '--color-yellow-100',
	PAYMENT_FAILED: '--color-red-100',
	TRIP_COMPLETED: '--color-green-100'
}
